import React from 'react';
import { useBemCN } from '@gik/core/utils/bemBlock';
import { useTranslation } from 'react-i18next';
import { translationKeys } from '@gik/contact/i18n/en';
import { Contact } from '@gik/contact';
import { PageSection } from '@gik/ui';

export interface IContactPageProps {}

const blockName = 'contact-page';

export function ContactPage(_props: IContactPageProps) {
  const bem = useBemCN(blockName);
  const { t } = useTranslation();

  return (
    <div {...bem()}>
      <PageSection variant={'aqua'}>
        <h1 {...bem('section-heading')}>{t(translationKeys.ContactPageHeading)}</h1>
      </PageSection>
      <Contact />
    </div>
  );
}
